import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { addNotify } from 'features/notify';
import { actions } from 'features/bonusProgram';

import { convertCreateBonusGift } from './convertCreateBonusGift';

const useCreateBonusGift = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const actionProcessing = useSelector(s => s.bonusProgram.actionProcessing);
  const currentGifts = useSelector(s => s.bonusProgram.currentGifts.items);
  const locale = useSelector(s => s.locale.locale);
  const id = useParams().id;

  const [state, setState] = useState({
    name: '',
    points: '',
    description: '',
    active: true,
    imageData: {
      image: '',
      ext: '',
      error: null,
    },
    imageUrl: '',
  });

  const handleNameChange = name => setState(ps => ({ ...ps, name }));
  const handlePointsChange = points => setState(ps => ({ ...ps, points }));
  const handleActiveChange = active => setState(ps => ({ ...ps, active }));
  const handleImageDataChange = imageData => setState(ps => ({ ...ps, imageData }));
  const handleCancelClick = () => history.push('/bonus-promo/management');

  const handleDescriptionChange = description => {
    if (description.length < 31) {
      setState(ps => ({ ...ps, description }));
    }
  };

  const handleSaveClick = e => {
    e.preventDefault();
    const action = id ? actions.editGift : actions.createGift;
    dispatch(action(convertCreateBonusGift({ id, ...state })));
  };

  useEffect(() => {
    if (id) {
      const targetGift = currentGifts.find(g => g.id === Number(id));

      if (targetGift) {
        setState(ps => ({
          ...ps,
          ...targetGift,
        }));
      } else {
        dispatch(addNotify(locale.giftNotFound, 'error'));
        history.push('/bonus-promo/management');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const isImageViable = (state.imageData.image && state.imageData.ext) || state.imageUrl;
  const disabled = !state.name || !state.description || !state.points || actionProcessing || !isImageViable;

  return {
    values: {
      actionProcessing,
      state,
      disabled,
    },
    handlers: {
      handleNameChange,
      handlePointsChange,
      handleDescriptionChange,
      handleActiveChange,
      handleImageDataChange,
      handleCancelClick,
      handleSaveClick,
    },
  };
};

export default useCreateBonusGift;
